import {BoxShadowRestDto, BoxShadowValueRestDto} from "@/api/pharma-cms-content-page/models";
import {BoxShadowValueRestDtoModel} from "@/models/api/pharma-cms-content-page/BoxShadowValueRestDtoModel";

export class BoxShadowRestDtoModel implements BoxShadowRestDto {
    layers: BoxShadowValueRestDto[];

    constructor(layers: BoxShadowValueRestDto[]) {
        this.layers = layers;
    }

    static createWithDefaults(): BoxShadowRestDtoModel {
        return new this([BoxShadowValueRestDtoModel.createWithDefaults()]);
    }

    static cloneFrom(source: BoxShadowRestDto): BoxShadowRestDtoModel {
        return new this(
            (source.layers ?? []).map((layer: BoxShadowValueRestDto) => BoxShadowValueRestDtoModel.cloneFrom(layer)),
        );
    }
}
